/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Afterpay visibility toggle based on variant price
  document.querySelectorAll('[data-section-type="product-template"]').forEach(function(section) {
    if (section.dataset.afterpayMinEnabled !== 'true') return;
    
    var minPrice = parseInt(section.dataset.afterpayMinPrice, 10) || 3000;
    
    section.addEventListener('theme:variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        section.classList.toggle('afterpay-hidden', e.detail.variant.price < minPrice);
      }
    });
  });


 // ─── Assortion Discount Badge Override ─────────────────────────────────────
  // Assortion's cart drawer hardcodes its discount badge as "X% off (a% + b%)"
  // with no admin setting to change it. This override rewrites the badge to
  // "X% + Y%" (multi-buy + subscription) or "X% off" (multi-buy only).
  //
  // Targets: .ast-cart__item .ast-tag__text
  // Data source: /cart.js
  // ───────────────────────────────────────────────────────────────────────────
  console.log('[AST Badge] Script loaded');

  var astBadgeTimer = null;
  var astLastBadgeText = null;

  function reformatAssortionBadges(cartData) {
    var items = cartData.items;

    var itemByHandle = {};
    items.forEach(function(item) {
      itemByHandle[item.handle] = item;
    });

    document.querySelectorAll('.ast-cart__item').forEach(function(cartItemEl) {
      var badge = cartItemEl.querySelector('.ast-tag__text');
      if (!badge) return;

      var link = cartItemEl.querySelector('a[href*="/products/"]');
      if (!link) return;

      var handle = link.getAttribute('href')
        .replace(/^\/products\//, '')
        .split('?')[0]
        .split('#')[0];

      var item = itemByHandle[handle];
      if (!item) {
        console.log('[AST Badge] No cart item for handle:', handle, '| handles available:', Object.keys(itemByHandle));
        return;
      }

      var subscriptionPercent = 0;
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        var adjustments = item.selling_plan_allocation.selling_plan.price_adjustments || [];
        for (var i = 0; i < adjustments.length; i++) {
          if (adjustments[i].value_type === 'percentage') {
            subscriptionPercent = Math.round(adjustments[i].value);
            break;
          }
        }
      }

      var allocations = item.line_level_discount_allocations || [];
      var multiBuyAmount = allocations.reduce(function(sum, alloc) {
        return sum + (alloc.amount || 0);
      }, 0);
      var originalLinePrice = item.original_line_price || 0;
      var multiBuyPercent = 0;
      if (multiBuyAmount > 0 && originalLinePrice > 0) {
        multiBuyPercent = Math.round(multiBuyAmount * 100 / originalLinePrice);
      }

      console.log('[AST Badge] handle:', handle, '| multiBuyPercent:', multiBuyPercent, '| subscriptionPercent:', subscriptionPercent, '| allocations:', allocations, '| selling_plan_allocation:', item.selling_plan_allocation);

      if (multiBuyPercent > 0 && subscriptionPercent > 0) {
        badge.textContent = multiBuyPercent + '% + ' + subscriptionPercent + '%';
      } else if (multiBuyPercent > 0) {
        badge.textContent = multiBuyPercent + '% off';
      }

      console.log('[AST Badge] Final badge text:', badge.textContent);
    });
  }

  function fetchAndReformatBadges() {
    var badges = document.querySelectorAll('.ast-cart__item .ast-tag__text');
    if (!badges.length) return; // No badges visible, skip fetch

    console.log('[AST Badge] Fetching /cart.js for', badges.length, 'badge(s)...');
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(reformatAssortionBadges)
      .catch(function(e) { console.error('[AST Badge] Fetch error:', e); });
  }

  function debouncedBadgeReformat() {
    clearTimeout(astBadgeTimer);
    astBadgeTimer = setTimeout(fetchAndReformatBadges, 300);
  }

  // ── MutationObserver: watch for any ast- prefixed elements added to DOM ──
  var astObserver = new MutationObserver(function(mutations) {
    var hasAstNodes = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        if (n.nodeType !== 1) return false;
        var cls = (typeof n.className === 'string') ? n.className : '';
        if (cls.indexOf('ast-') !== -1) return true;
        if (n.querySelector && n.querySelector('[class*="ast-cart"]')) return true;
        return false;
      });
    });
    if (hasAstNodes) {
      console.log('[AST Badge] ast- node detected in DOM');
      debouncedBadgeReformat();
    }
  });

  astObserver.observe(document.body, { childList: true, subtree: true });

  // ── Click listener: catch cart open/close and quantity changes ───────────
  // Assortion renders lazily — firing after any click covers cart toggle,
  // quantity buttons, and variant changes.
  document.addEventListener('click', function() {
    setTimeout(function() {
      if (document.querySelector('.ast-cart__item .ast-tag__text')) {
        debouncedBadgeReformat();
      }
    }, 500);
  });
  // ─── End Assortion Discount Badge Override ──────────────────────────────────

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
